import { useParams } from 'react-router-dom';
import { InvalidCircleIdError } from '../../../../shared/models/errors/invalid-circle-id-error';
import { useQuery } from '@tanstack/react-query';
import { useCircleQueries } from '../../../../shared/tanstack/circle/queries';
import Panel from '../../../../shared/components/panel/page';
import getMemberType from '../../member-type';

export default function CircleParticipantsContainer() {
	const { id: circleId } = useParams();
	const { circleQuery } = useCircleQueries();
	if (!circleId) {
		throw new InvalidCircleIdError();
	}
	const { data: circle } = useQuery(circleQuery(circleId));
	let member: string | undefined;
	const circleType = circle?.type;
	if (circleType) {
		member = getMemberType(circleType)?.pluralTitle;
	}
	return <Panel title={circle?.name ?? ''} subtitle={`View & manage ${circle?.name ?? ''}'s ${member ?? ''}`} />;
}
